import { useEffect, useContext, useState } from "react";
import { GlobalContext } from "../../hooks/globalContext";
import apiCall from "../../utility/api";

interface iFilter {
	operator: string;
	value: string | number | string[];
}

type typeData = {
	func?: any;
	data?: any;
	pageNo?: any;
	jsonData?: any;
	uiData?: any;
	setJsonData?: any;
	setUiData?: any;
	saveBtnClicked?: any;
	editBtnClicked?: any;
	formDataAlert?: any;
	formData?: any;
	setSaveBtnClicked?: any;
	setEditBtnClicked?: any;
	setFormDataAlert?: any;
	setToastAlertCreate?: any;
	setToastAlertEdit?: any;
	rowID?: any;
	setRowID?: any;
	handleEditData?: any;
	setToastAlertError?: any;
	criteriaList?: any
	criteriaList2?: any
	criteriaList3?: any
	setToastAlertDelete?: any
	setIsDeleteAlert?: any
	deleteAlert?: any
	setTotalRecords?: any
	totalRecords?: any
	setTotalPages?: any
	isRefresh?: any
	setIsRefresh?: any
	setExportDetails?: any;
	importedDataInserted?: any
	setSearchVal?: any
	searchVal?: any
	userActivity?: any
	renderToast?: any
	toastAlertError?: any
	filterArray?: any
	isfilter?: boolean
	tenant: string
	exportBtnClicked?: any
	setExportBtnClicked?: any
	setTroubleshooterList?: any
	overlayOpen?: any
	setFormData?: any
	selectedTroubleshooterList?: any
	setLoading?: any;
	setSpinnerLoad?: any
};


export const Alert_func: any = (props: typeData) => {
	const [row_id, setRow_id] = useState();
	const [dartList, setDartList] = useState([]);
	const [prevoiusResultId, setPreviousResultId] = useState(0);

	const contextValue: any = useContext(GlobalContext);
	var tenantName = contextValue.tenantName;

	const getshooterList = async (whereCondition: any, limit: any, offset: any, listType: String = '') => {
		try {
			let { data, status } = await apiCall('/troubleshoot/getTroubleshootList', { ...whereCondition, limit, offset });
			// let automationList: string[] = [];
			let uniqueAutomationList: Set<string> = new Set();
			if (Array.isArray(data)) {
				data.forEach((item: any) => {
					if (item?.automationName) { uniqueAutomationList.add(item.automationName) }
				});
			}
			const automationList = Array.from(uniqueAutomationList);
			props.setTroubleshooterList(automationList);
			console.log("checking automationList +++", automationList)
		} catch (error) {
			console.log('getTroubleshootList error= ', error);
		};
	};

	useEffect(() => {

		
		if (props.rowID) {
			console.log("testingggg");
			setRow_id(props.rowID);
			getAlertDetails();
		}
		else if (props.editBtnClicked === true) {
			updateAlertDetails(row_id);
			props.setEditBtnClicked(false);
			props.setFormDataAlert({});
			props?.setFormData({})
			// props.setToastAlertEdit(true);
		} else if (props.saveBtnClicked == true) {
			if (prevoiusResultId != 0) { addAlert() } // addAlert(props, contextValue);
			props.setSaveBtnClicked(false);
			props.setFormDataAlert({});
			// props.setToastAlertCreate(true);
		} else if (props.deleteAlert == true) {
			deleteAlert(contextValue.selectedRowIdInTable)
		} else if (props.searchVal.length > 0 && props.searchVal !== '') {
			getAlertsList("search", { name: props.searchVal }, 50, parseInt(props.pageNo));
			getAlertsListCnt("search", { name: props.searchVal })
		} else if (props.isfilter === true) {
			getAlertsList("filter", { filter: props.filterArray }, 50, parseInt(props.pageNo));
			getAlertsListCnt("filter", { filter: props.filterArray });
		} 
		else {
			if (!props.overlayOpen) {
				getAlertsList(null, null, 50, parseInt(props.pageNo));
				getAlertsListCnt(null)
			}
		}
	}, [
		prevoiusResultId, props.isfilter, props.filterArray, props.importedDataInserted, props.jsonData,
		props.uiData, props.saveBtnClicked, props.rowID, props.editBtnClicked, props.deleteAlert, props.searchVal,
		props.criteriaList, props.criteriaList2, props.criteriaList3
	]);

	useEffect(() => {
		if (props.exportBtnClicked === true) {
			getExportData({ function: 'export', tenant: props.tenant });
		}
		if (props.isRefresh===true) {
			getAlertsList(null, null, 50, parseInt(props.pageNo));
			getAlertsListCnt(null);
		}
	}, [props.isRefresh, props.exportBtnClicked])


	useEffect(() => {
		if (props.overlayOpen && dartList?.length>0) {
			getshooterList({ types: ["selfhelp", "proactive"], tenant: `${tenantName}` }, 0, 0);
			getPreviousResultId();
			getJosnSchemaData();
		}
	}, [props.overlayOpen,dartList]);

	useEffect(()=>{
		if (dartList.length === 0&&props?.overlayOpen===true) {
			fetchDartList();
		}
	},[dartList,props?.overlayOpen])

	const fetchDartList = async () => {
		try {
			const url = '/event/getEvents';
			const { status, data } = await apiCall(url, undefined);
			if (data && status === 'success') { setDartList(data) }
		} catch (error) {
			console.log("fetchDartList error=", error);
		}
	};

	const getPreviousResultId = async () => {
		try {
			const { status, data } = await apiCall('/alerts/getPreviousId')
			if (status === "success" && data !== undefined) { setPreviousResultId(data.id) }
		}
		catch (error) {
			console.error("An unexpected Error occured at getPreviousResultID Query", (error as Error).message)
		}
	}

	const getAlertsList = async (
		type: string | null = '',
		searchVal: any = null,
		limit: Number = 50,
		offset: Number = 0
	) => {
		try {
			let { status, data } = await apiCall('/alerts/getAlertsList', { type, searchVal, limit, offset })
			if (status === 'success') {
				props.func(data);
			} else {
				props.func([]);
			}
		} catch (error) {
			console.error("An unexpected error occurred at AlertList API call:", (error as Error).message);
			props.func([]);
		}
	};

	const getExportData = async (condition: object) => {
		try {
			const { status, data } = await apiCall(`/alerts/getAlertsList`, { ...condition });
			// Spread the condition object to pass all expected keys
			if (status === 'success') {
				props.setExportDetails && props.setExportDetails(data);
			}
		} catch (error) {
		}
		props.setExportBtnClicked(false);
	}

	const getAlertsListCnt = async (type: string | null = '', searchVal: any = null) => {
		try {
			let { status, data } = await apiCall('/alerts/getAlertsListCount', { type, searchVal })
			if (status === 'success') {
				props.setTotalRecords(data);
				props.setTotalPages(Math.ceil((data) / 50));
			}
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
			// Handle unexpected errors, log them, and potentially notify the user
		}
	};

	const getAlertDetails = async () => {
		const Id = props.rowID;
		try {
			const { status, data } = await apiCall('/alerts/getAlertDetails', { Id })
			if (status === "success" && data != undefined) {
				props.handleEditData(data);
				props.setSpinnerLoad(false);
			} else {
				props.handleEditData(data);
				props.setSpinnerLoad(false);
			}
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
		}
	};

	const createQuery = (response: any) => {
		// Extract necessary variables
		console.log("response", response)
		const measureCount = response?.SetMeasures[0]?.setCount;
		const timeFrameType = response?.SetMeasures[0]?.timeFrame;
		const dartNumber = response?.alertconditional[0]?.SelectDart;
		const dartNumber2 = response?.alertnextCondition?.SelectDart;
		const timeFrameValue = (() => {
			switch (timeFrameType) {
				case "Minutes": return props?.formDataAlert?.SetMeasures[0]?.timeFrameMinutes;
				case "Hours": return props?.formDataAlert?.SetMeasures[0]?.timeFrameHours;
				case "Days": return props?.formDataAlert?.SetMeasures[0]?.timeFrameDays;
				case "Months": return props?.formDataAlert?.SetMeasures[0]?.timeFrameMonths;
				default: return null;
			}
		})();
		const conditions: string[] = [];

		const valueFunc = (cond: any) => {
			const operator = cond.ConditionType;
			const conditionValues = cond.ConditionValue;
			const renderOperator = (operator === 'like start%' || operator === 'like %end') ? 'like' : operator;

			const value = (() => {
				switch (operator) {
					case 'like':
						return `%${conditionValues}%`;
					case 'not like':
						return `%%${conditionValues}`;
					case 'like start%':
						return `${conditionValues}%`;
					case 'like %end':
						return `%${conditionValues}`;
					default:
						return conditionValues;
				}
			})();

			return { renderOperator, value };
		};

		// Build conditions from alertconditional
		response?.alertconditional?.forEach((item: any) => {
			item?.conditionals?.forEach((cond: any) => {
				const { renderOperator, value } = valueFunc(cond.lastCondition);
				conditions.push(`${cond.setCriteria} ${renderOperator} '${value}' AND scrip = '${dartNumber}'`);
			});
		});

		// Add alertnextCondition
		response?.alertnextCondition?.conditionals?.forEach((cond: any) => {
			const { renderOperator, value } = valueFunc(cond.lastCondition);
			conditions.push(`${cond.setCriteria} ${renderOperator} '${value}' AND scrip = '${dartNumber2}'`);
		});

		// Join conditions with And_Or
		const whereClause = response.And_Or ? conditions?.join(` ${response.And_Or === "&&" ? 'AND' : 'OR'} `) : conditions;

		// Construct the query
		return `
		  SELECT count(*), machine, scrip,
		  '${props?.formData?.name}' AS Name, '${response.type}' AS type,
		  window_start, window_end
		  FROM TUMBLE(${process.env.REACT_APP_RAISINGWAVE_QUERY}, servertime, INTERVAL '${timeFrameValue} ${timeFrameType}')
		  WHERE ${whereClause}
		  GROUP BY window_start, window_end, machine, scrip
		  HAVING COUNT(*) >= ${measureCount}`;
	};

	const updateAlertDetails = async (row_id: any) => {
		try {
			const rowId = row_id;
			const name = props?.formData?.name;
			const description = props?.formData?.description;
			const solutions = JSON.stringify(props?.selectedTroubleshooterList);
			const createdBy = contextValue.userSessionDetails.userName;
			const lastModified = Math.floor(Date.now() / 1000);
			const variables = createQuery(props?.formDataAlert);

			const formDataEdit = JSON.stringify(props?.formDataAlert);

			const resultData = await apiCall('/alerts/updateAlert', {
				rowId, formDataEdit, variables, createdBy, name, lastModified, description, solutions
			});

			if (resultData.status === "success" && resultData?.data) {
				if (resultData.data.affected_rows > 0) {
					getAlertsList(null, 50, parseInt(props.pageNo));
					getAlertsListCnt(null);
					props.setRowID(null);
					props.setToastAlertEdit(true);
				} else {
					props.setToastAlertError(true);
				}
			} else {
				props.setToastAlertError(true);
			}
		} catch (error) {
			console.error("Error updating alert:", error instanceof Error ? error.message : error);
			props.setToastAlertError(true);
		}
	};

	const deleteAlert = async (row_id: any) => {
		const id = row_id
		try {
			const { status, data } = await apiCall('/alerts/deleteAlert', { id })
			if (status === "success" && data?.affected_rows > 0) {
				props.setRowID(null);
				props.setIsDeleteAlert(false)
				props.setToastAlertDelete(true)
				contextValue.setSelectedRowIdInTable([])
			} else {
				// props.userActivity('Delete', `{"summary":"${contextValue.selectedRowIdInTable.length} ${contextValue.selectedRowIdInTable?.length < 2 ? 'alert' : 'alerts'} deletion failed"}`);
			}
		} catch (error) {
			console.error("An unexpected error occurred: DELETE ALERT", (error as Error).message);
			// props.userActivity('Delete', `{"error":"${error}","summary":"${contextValue.selectedRowIdInTable.length} ${contextValue.selectedRowIdInTable?.length < 2 ? 'alert' : 'alerts'} deletion failed"}`);
		}
	}

	const addAlert = async () => {
		const name = props?.formData?.name;
		const description = props?.formData?.description;
		const solutions = JSON.stringify(props?.selectedTroubleshooterList);
		const createdBy = contextValue.userSessionDetails.userName;
		const createdOn = Math.floor(Date.now() / 1000);
		const lastModified = Math.floor(Date.now() / 1000);
		const status = "Not Attached";

		const variables = createQuery(props.formDataAlert)

		const allFormData = { ...props?.formDataAlert, ...props?.formData };

		const formDataEdit = JSON.stringify(allFormData);

		try {
			const dataResult = await apiCall('/alerts/createAlert', {
				formDataEdit, variables, createdBy, createdOn, name, lastModified, status, description, solutions
			});
			if (dataResult.status === 'success' && dataResult?.data?.affected_rows > 0) {
				props.setToastAlertCreate(true);
				getAlertsList(null, 50, parseInt(props.pageNo));
				getAlertsListCnt(null);
			} else {
				props.setToastAlertError(true);
			}
		} catch (error) {
			console.error("Error in adding new ALERT to notification=", error);
			props.setToastAlertError(true);
		}
	};


	const getJosnSchemaData = async () => {
		try {
			const dartId = 2002
			let { status, data } = await apiCall('/alerts/getSchema', { dartId })
			if (data && status === 'success') {
				var jsonValue = JSON.parse(data?.[0]?.jsonSchema);
				const { type, priority, SetMeasures, And_Or} = jsonValue.properties;
                
				// Safely access dartList with optional chaining and type checking
				const enums = Array.isArray(dartList) ? dartList.map((data) => data.scrip) : [];
				const enumNames = Array.isArray(dartList) ? dartList.map((data) => data.description) : [];
				const alertconditionalArray = {};

				const schema = {
					type: "object",
					properties: {
						"type": type,
						"priority": priority,
						"SetMeasures": SetMeasures,
						alertconditional: {
							title: " ",
							items: {
								$ref: "#/definitions/person",
							},
							type: "array",
							minItems: 1,
							maxItems: 1
						},
						"And_Or":And_Or
					},
					"required": [
						"type",
						"priority",
						"SetMeasures"
					],
					dependencies: {
						And_Or: {
							oneOf: [
								{
									properties: {
										And_Or: { const: "&&" },
										alertnextCondition: {
											$ref: `#/definitions/person`,
										},
									}
								},
								{
									properties: {
										And_Or: { const: "||" },
										alertnextCondition: {
											$ref: `#/definitions/person`,
										},
									}
								}
							]
						}
					},
					definitions: {
						person: {
							title: " ",
							properties: {
								"SelectDart": {
									title: "Select the darts whose events must be considered",
									type: "string",
									enum: enums,
									enumNames: enumNames,
								},
							},
							"required": [
								"SelectDart",
							],
							dependencies: {
								"SelectDart": {
									oneOf: dartList?.map((data, index) => ({
										properties: {
											"SelectDart": {
												enum: [data.scrip],
											},
											conditionals: {
												title: " ",
												items: {
													$ref: `#/alertconditionalArray${index + 1}/person`,
												},
												type: "array",
												minItems: 1,
												maxItems: 1
											},
										},
									})),
								},
							},
						},
					},
					LastCondition: {}
				};

				dartList?.forEach((data, index) => {
					const key = `alertconditionalArray${index + 1}`;
					// Safely parse the param JSON with error handling
					let jsonData;
					try {
						jsonData = JSON.parse(data?.param);
					} catch (parseError) {
						console.error(`Error parsing param for index ${index}:`, parseError);
						console.log('Problematic param string:', data?.param);
						return;
					}

					const jsonparamKeys = Object.keys(jsonData);
					const disabledOptions = jsonparamKeys.filter(
						(key) => jsonData[key].visibility === "disabled"
					);

					const paramsId = jsonparamKeys.map((key) => {
						if (jsonData[key].alerts === "Yes") {
							return jsonData[key]["pinot_column"]
						} else {
							return null
						}
					}
					).filter(data => data !== null);

					const paramKeys = jsonparamKeys.map((key) => {
						if (jsonData[key].alerts === "Yes") {
							return key
						} else {
							return null
						}
					}
					).filter(data => data !== null);


					const conditionArraysForKey = {
						person: {
							title: "Set Filters:",
							type: "object",
							properties: {
								"setCriteria": {
									type: "string",
									title: "Set Criteria",
									enum: paramsId,
									enumNames: paramKeys,
								},
							},
							"required": [
								"setCriteria",
							],
							dependencies: {
								"setCriteria": {
									oneOf: paramKeys.map((param, idx) => {
										const datatype = jsonData[param]?.datatype || "String";
										const conditionOptions = {
											enum: datatype === "String"
												? ["=", "!=", "like", "not like", "like start%", "like %end"]
												: ["=", "!=", ">=", "<=", ">", "<"],
											enumNames: datatype === "String"
												? ["Equal to", "Not Equal to", "Contains", "Does not contain", "Begins with", "Ends with"]
												: ["Equal to", "Not Equal to", "Greater than or equal", "Less than or equal", "Greater than", "Less than"],
										};

										const lastConditionKey = `LastCondition_${key}_${param}`;

										if (!schema.LastCondition[lastConditionKey]) {
											schema.LastCondition[lastConditionKey] = {
												person: {
													title: " ",
													type: "object",
													properties: {
														ConditionType: {
															title: "Logical Operators",
															type: "string",
															...conditionOptions,
														},
														ConditionValue: {
															title: "Enter the Value",
															type: "string",
														},
													},
													"required": [
														"ConditionType",
														"ConditionValue"
													]
												},
											};
										}

										return {
											properties: {
												"setCriteria": {
													enum: [paramsId[idx]],
												},
												lastCondition: {
													$ref: `#/LastCondition/${lastConditionKey}/person`,
													title: " ",
													type: "object",
												},
											},
										};
									}),
								},
							},
						},
						uiSchema: {
							"Select the event from the dropdown": {
								"ui:enumDisabled": paramsId.filter((id, idx) =>
									disabledOptions.includes(paramKeys[idx])
								),
							},
						},
					};

					alertconditionalArray[key] = conditionArraysForKey;
				});

				const uiSchemaValue = {
					"And_Or": {
						"ui:widget": "radio",
						"ui:options": {
							"inline": true
						},
						"ui:submitButtonOptions": {
							"norender": true
						}
					}
				}

				var uiValue = JSON.parse(data?.[0]?.uiSchema);
				console.log("uiValue",uiValue)
				data?.[0]?.jsonSchema !== undefined && props.setJsonData({ ...schema, ...alertconditionalArray });
				data?.[0]?.uiSchema !== undefined && props.setUiData(uiSchemaValue);
			}
		} catch (error) {
			console.error("An unexpected error occurred Alert Json schema:", (error as Error).message);
		}
	};
	
};
export default Alert_func;
